import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "../styles/occupancy-filter.module.scss";

import { ResourceRequester } from "sulu-admin-bundle/services";

import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const OccupancyFilter = ({ pitch, venueId, selectHandler }) => {
    const [allPitches, setAllPitches] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        ResourceRequester.getList("dhbpitches", {
            location: venueId,
            limit: 100,
        })
            .then((response) => {
                setAllPitches(response._embedded.dhbpitches);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    return (
        <div className={styles["occupancy-filter"]}>
            <FormControl fullWidth>
                <InputLabel id="pitch-select-label">
                    {t("sulu_admin.filter_by_pitch")}
                </InputLabel>
                <Select
                    labelId="pitch-select-label"
                    value={pitch}
                    onChange={selectHandler}
                    label={t("sulu_admin.filter_by_pitch")}
                >
                    <MenuItem value="all">
                        <em>{t("sulu_admin.all_pitches")}</em>
                    </MenuItem>
                    {allPitches.map((singlePitch) => (
                        <MenuItem
                            key={singlePitch.id}
                            value={singlePitch.id}
                            name={singlePitch.name}
                        >
                            {singlePitch.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default OccupancyFilter;
